import { inject } from '@angular/core';
import { SessionService } from '@core';

/**
 * Inicializador de la aplicación.
 * No llama a refresh aquí: los guards (authGuard, noAuthGuard) intentan restaurar sesión
 * al activar la ruta, así se evita un 401 en consola desde el initializer.
 */
export function appInitializer(): () => Promise<void> {
  return () => {
    const sessionService = inject(SessionService);
    const path = typeof window !== 'undefined' ? window.location.pathname : '';
    if (path === '/login' || path.startsWith('/login/')) {
      sessionService.clearSession();
    }
    return Promise.resolve();
  };
}
